import { render, staticRenderFns } from "./AdditionalChatActions.vue?vue&type=template&id=4ef376a0&"
import script from "./AdditionalChatActions.vue?vue&type=script&lang=ts&"
export * from "./AdditionalChatActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports